import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { themeFontsAndColorsCompNode } from './themeFontsAndColorsCompNode'
import { ThemeFontsAndColorsCssFeature } from './themeFontsAndColors.types'
import { themeFontsAndColorsDomApplier } from './themeFontsAndColorsDomApplier'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const themeFontsAndColorsCssFeature: ThemeFontsAndColorsCssFeature = {
	experimentName: 'OPEN_TO_ALL',
	featureName: 'themeFontsAndColors',
	renderableNodes: { themeFontsAndColorsCssStyle: themeFontsAndColorsCompNode },
	// @ts-ignore TODO: remove once added to EE types
	intermediateNodes: { directionWithOptInRtlSupport: compInfoNodes.directionWithOptInRtlSupport },
	dataMaps: ['theme_data'],
	domApplier: themeFontsAndColorsDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(themeFontsAndColorsCssFeature)
}

export const editor: BindFeature = page
